import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractLongFormInstructionsFromUrl($projectId: ID, $sectionId: ID!, $url: String!) {
    extractLongFormInstructionsFromUrl(projectId: $projectId, sectionId: $sectionId, url: $url) {
      instructions
      status
      extractionErrors
    }
  }
`;

export const extractLongFormInstructionsFromUrl = ({ projectId, sectionId, url }) => {
  const variables = { projectId, sectionId, url };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
